import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import formatHoursOfOperation from './openingHours';
function formatPostalAddress(location) {
  var hours = null;
  var openedHours = location.hours.filter(function (_ref) {
    var open = _ref.open,
      close = _ref.close;
    return !!open && !!close;
  });
  var isOpenSomeDay = openedHours.length > 0;
  if (isOpenSomeDay) {
    hours = formatHoursOfOperation(openedHours);
  }
  return {
    '@type': 'PostalAddress',
    addressLocality: location.city,
    addressRegion: location.state,
    streetAddress: location.street,
    email: location.email,
    telephone: location.phoneNumber,
    name: location.name,
    hoursAvailable: hours
  };
}
export default function formatAddress(address) {
  if (_isEmpty(address)) {
    return null;
  }
  if (typeof address === 'string') {
    return address;
  }
  if (_isArray(address)) {
    return formatPostalAddress(address[0]);
  }
  return formatPostalAddress(address);
}